import PipelineName from "../icons/monitoring-deepdive-icons/waterPipedp.svg"
import Market from "../icons/monitoring-deepdive-icons/Group 513569.svg"
import PipelineStage from "../icons/monitoring-deepdive-icons/Group 513570.svg"
import Progress from "../icons/monitoring-deepdive-icons/Group 513571.svg"
import SegmentsCompleteStatus from "../icons/monitoring-deepdive-icons/Group 513572.svg"
import StartDateAndTime from "../icons/monitoring-deepdive-icons/Group 513572.svg"
import ParametersPassed from "../icons/monitoring-deepdive-icons/Group 513573.svg"
import Close from "../icons/monitoring-deepdive-icons/close.svg"
import Loading from "../icons/monitoring-deepdive-icons/circularInprogress.svg"
export const icons: any = {
  monitoringDeepDiveImages: [
    PipelineName,
    Market,
    PipelineStage,
    Progress,
    SegmentsCompleteStatus,
    StartDateAndTime,
    StartDateAndTime,
    ParametersPassed,
  ],
  close: Close,
  monitoringLoadingIcon: Loading,
}
